module.exports = __webpack_public_path__ + "img/vocabulary.926aa5e6.svg";